module.exports = __webpack_public_path__ + "img/terraceday.0cb42604.jpg";